import _regeneratorRuntime from "babel-runtime/regenerator";

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import memoize from "fast-memoize";

var id = 0;
function memoizedId(x) {
  if (!x.__memoizedId) x.__memoizedId = ++id;
  return { __memoizedId: x.__memoizedId };
}

export default memoize(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(api) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _ref2, success, data, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.apply(undefined, args);

          case 3:
            _ref2 = _context.sent;
            success = _ref2.success;
            data = _ref2.data;
            message = _ref2.message;

            if (!(success === 0)) {
              _context.next = 9;
              break;
            }

            throw new Error(message);

          case 9:
            return _context.abrupt("return", data);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            throw _context.t0;

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 12]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), {
  cache: {
    create: function create() {
      var store = {};
      return {
        has: function has(key) {
          return key in store;
        },
        get: function get(key) {
          return store[key];
        },
        set: function set(key, promise) {
          promise.then(function (value) {
            if (value) {
              store[key] = promise;
            }
          });
        }
      };
    }
  },
  serializer: function serializer(args) {
    var argumentsWithFuncIds = Array.from(args).map(function (x) {
      if (typeof x === "function") return memoizedId(x);
      return x;
    });
    return JSON.stringify(argumentsWithFuncIds);
  },
  strategy: memoize.strategies.variadic // 支持可变参数
});